import React, { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { AuthFrame } from "@/layout/AuthFrame";
import { Btn, Field } from "@/components/kit";
import { Subs } from "@/components/Subs";
import { useAuth } from "@/context/AuthContext";
import { apiError } from "@/lib/api";
import { toast } from "@/components/ui/sonner";

export default function Register() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const prefill = new URLSearchParams(location.search).get("email") || "";
  const [name, setName] = useState("");
  const [email, setEmail] = useState(prefill);
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!name || !email || !password) return toast.error("Please fill in all fields.");
    if (password.length < 10) return toast.error("Password must be at least 10 characters.");
    setLoading(true);
    try {
      await register(name.trim(), email.trim(), password);
      navigate("/");
    } catch (err) {
      toast.error(apiError(err, "Unable to create account."));
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthFrame>
      <h1 className="font-serif text-4xl text-ink text-center"><Subs>Meet ME₀</Subs></h1>
      <p className="text-inkfaint text-center mt-2 mb-8">
        Create your private space. Everything you write stays yours.
      </p>
      <form onSubmit={submit} className="space-y-4" data-testid="register-form">
        <Field label="Your name" placeholder="What shall we call you?" value={name}
          onChange={(e) => setName(e.target.value)} data-testid="register-name" autoComplete="name" />
        <Field label="Email" type="email" placeholder="you@example.com" value={email}
          onChange={(e) => setEmail(e.target.value)} data-testid="register-email" autoComplete="email" />
        <Field label="Password" type="password" placeholder="At least 10 characters" value={password}
          onChange={(e) => setPassword(e.target.value)} data-testid="register-password" autoComplete="new-password" />
        <Btn type="submit" className="w-full" disabled={loading} data-testid="register-submit">
          {loading ? "Creating…" : "Create account"}
        </Btn>
      </form>
      <p className="text-center text-sm text-inkfaint mt-8">
        Already have an account?{" "}
        <Link to="/login" className="text-gold hover:underline" data-testid="to-login">Sign in</Link>
      </p>
    </AuthFrame>
  );
}
